<template>
  <div
    id="email_activity"
    class="flex flex-col gap-4 overflow-y-auto custom_scrollbar"
    style="max-height: 79vh"
  >
    <template v-for="(item, index) in activity">
      <EmailMessageActivity
        v-if="item.activity_type === 'message'"
        :activity="item"
        :key="`message-${item._id || item.id || index}`"
        :is-selected="isItemSelected(item)"
        @click="selectItem(item)"
      />
    </template>
  </div>
</template>

<script setup>
import EmailMessageActivity from "@/src/components/emails/EmailMessageActivity.vue";
import { ref, onMounted, nextTick, computed, provide } from "vue";

const props = defineProps({
  message: { type: Object, required: true },
  activity: { type: Object, required: true },
  engagement: { type: Object, default: () => ({}) },
  selectedMessageId: { type: String, default: "" },
});
provide("allActivities", props.activity);

const selectedItems = ref(new Set());
onMounted(() => {
  if (props.message && props.message?._id) {
    nextTick(() => {
      selectedItems.value.clear();
      const initialItem = props.activity.find(
        (item) =>
          item.activity_type === "message" && item?._id === props.message?._id,
      );

      const itemToSelect =
        initialItem ||
        (props.activity.length > 0 &&
          props.activity.find((item) => item.activity_type === "message"));

      if (itemToSelect) {
        selectedItems.value.add(itemToSelect?._id);
      }
    });
  }
});

const isItemSelected = (item) => {
  return selectedItems.value.has(item?._id);
};

const selectItem = (item) => {
  if (!selectedItems.value.has(item?._id)) {
    selectedItems.value.add(item?._id);
  }
};
</script>
